import React, { useEffect, useState } from "react";
import { getProfileData } from "../../../apis/auth";
import RenderRazorpay from "../../../razorpay";
import { createNewFinancerPayment } from "../../../apis/financers";

const Profile = () => {
  const [profile, setProfile] = useState<any | undefined>();
  const [profileType, setProfileType] = useState("");
  const [transactAmount, setTransactAmount] = useState<number | undefined>();
  const [aadharAmount, setAadharAmount] = useState<number | undefined>();
  const [smsTokenAmount, setSmsTokenAmount] = useState<string | undefined>();
  const [openRazorPay, setOpenRazorPay] = useState<boolean | false>();
  const [aadharTokenAmount, setAadharTokenAmount] = useState<
    string | undefined
  >();

  const smsCharges = 0.3;
  const aadharCharges = 4;
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { value } = e.target;
    setSmsTokenAmount(value);
  };

  useEffect(() => {
    if (smsTokenAmount) {
      const amount = parseFloat(smsTokenAmount);
      if (!isNaN(amount)) {
        const calculatedAmount = amount * smsCharges;
        setTransactAmount(Math.round(calculatedAmount * 100) / 100);
      } else {
        setTransactAmount(undefined);
      }
    }
    if (aadharTokenAmount) {
      const amount = parseFloat(aadharTokenAmount);
      if (!isNaN(amount)) {
        const calculatedAmount = amount * aadharCharges;
        setAadharAmount(Math.round(calculatedAmount * 100) / 100);
      } else {
        setAadharAmount(undefined);
      }
    }
  }, [smsTokenAmount, aadharTokenAmount]);

  const handlepayment = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      const payload = {
        financer_id: profile?.id,
        transaction_amount: Number(transactAmount),
        sms_token_limit: Number(smsTokenAmount),
      };
      const response = await createNewFinancerPayment(payload);
      setOpenRazorPay(true);
    } catch (error) {
      console.error(error, "error");
    }
    setTransactAmount(undefined);
  };
  const handleAadhar = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      const payload = {
        financer_id: profile?.id,
        transaction_amount: Number(aadharAmount),
        aadhar_token_limit: Number(aadharTokenAmount),
      };
      const response = await createNewFinancerPayment(payload);
      setOpenRazorPay(true);
    } catch (error) {
      console.error(error, "error");
    }
    setTransactAmount(undefined);
  };

  const fetchProfileData = async () => {
    try {
      const response = await getProfileData();
      setProfile(response.data);
    } catch (error) {
      console.error(error, "error");
    }
  };

  useEffect(() => {
    fetchProfileData();
    const profileData = sessionStorage.getItem("info");
    if (profileData) {
      try {
        const parsedData = JSON.parse(profileData);
        const ptype = parsedData.type;
        setProfileType(ptype);
      } catch (error) {
        console.error("Error parsing profile data:", error);
      }
    }
  }, []);

  const submitButton = () => {};

  const addressDetails = JSON.parse(profile?.address || "{}");

  const fields = [
    { label: "Full Name", value: profile?.full_name, icon: "fa-user" },
    { label: "Email", value: profile?.email, icon: "fa-envelope" },
    {
      label: "Mobile Number",
      value: profile?.phone_number,
      icon: "fa-phone",
    },
    { label: "Id", value: profile?.id, icon: "fa-id-badge" },
  ];

  const AddressFields = [
    {
      label: "Address",
      value: addressDetails.addressLine,
      icon: "fa-map-marker-alt",
    },
    { label: "City", value: addressDetails.city, icon: "fa-city" },
    { label: "State", value: addressDetails.state, icon: "fa-flag" },
    { label: "Country", value: addressDetails.country, icon: "fa-globe" },
    { label: "Pin Code", value: addressDetails.pincode, icon: "fa-mail-bulk" },
  ];

  const otherInformationFields = [
    {
      label: "Company Name",
      value: profile?.company_name,
      icon: "fa-building",
    },
    {
      label: "GST Number",
      value: profile?.gst_number,
      icon: "fa-receipt",
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="card shadow-sm rounded-3 border-0">
          <div className="card-header bg-primary text-white py-3">
            <h2 className="mb-0 text-center text-white">Profile</h2>
          </div>

          {profileType === "financer" && (
            <div className="head-icons ms-2 " style={{ marginTop: 10 }}>
              <div
                className="me-3"
                style={{
                  display: "flex",
                  gap: "10px",
                  width: "100%",
                  justifyContent: "end",
                }}
              >
                <div>
                  <button
                    data-bs-toggle="modal"
                    data-inert={true}
                    data-bs-target="#sms_wallet"
                    className="btn btn-primary"
                  >
                    Sms Wallet
                  </button>
                </div>
                <div>
                  <button
                    data-bs-toggle="modal"
                    data-inert={true}
                    data-bs-target="#aadhar_wallet"
                    className="btn btn-primary"
                  >
                    Aadhar Wallet
                  </button>
                </div>
              </div>
            </div>
          )}
          <div className="card-body p-4">
            <div className="row ">
              <div className="col-md-12">
                <div>
                  <div className="d-flex align-items-center flex-wrap bg-light w-100 rounded p-3 ">
                    <div className="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames">
                      <img alt="Profile Image" src={profile?.profile_pic} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row g-2  ">
                {fields?.map((field, index) => (
                  <div key={index} className="col-md-6">
                    <p className="info">
                      <span className="info-label">
                        <i className={`fas ${field.icon}`}></i> {field.label} :
                      </span>
                      <span className="info-value">
                        {" "}
                        {field.value || "N/A"}
                      </span>
                    </p>
                  </div>
                ))}

                {AddressFields?.map((field, index) => (
                  <div key={index} className="col-md-6">
                    <p className="info">
                      <span className="info-label">
                        <i className={`fas ${field.icon}`}></i> {field.label} :
                      </span>
                      <span className="info-value">
                        {" "}
                        {field.value || "N/A"}
                      </span>
                    </p>
                  </div>
                ))}
                {otherInformationFields?.map((field, index) => (
                  <div key={index} className="col-md-6">
                    <p className="info">
                      <span className="info-label">
                        <i className={`fas ${field.icon}`}></i> {field.label} :
                      </span>
                      <span className="info-value">
                        {" "}
                        {field.value || "N/A"}
                      </span>
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="modal fade" id="sms_wallet">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <div className="d-flex align-items-center">
                  <h4 className="modal-title me-2">Sms Wallet</h4>
                </div>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>

              <form onSubmit={handlepayment}>
                <div className="contact-grids-tab">
                  <ul className="nav nav-underline" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="info-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#basic-info"
                        type="button"
                        role="tab"
                        aria-selected="true"
                      >
                        Basic Information
                      </button>
                    </li>
                    <li className="nav-item" role="presentation"></li>
                  </ul>
                </div>
                <div className="tab-content" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="basic-info"
                    role="tabpanel"
                    aria-labelledby="info-tab"
                    tabIndex={0}
                  >
                    <div className="modal-body pb-0 ">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Sms Token Wallet
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="number"
                              value={smsTokenAmount || ""} // Provide a default value for controlled input
                              onChange={handleChange}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Transaction Amount
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="number"
                              value={transactAmount || ""}
                              className="form-control"
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-outline-light border me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        data-bs-dismiss="modal"
                        className="btn btn-primary"
                      >
                        Submit{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="modal fade" id="aadhar_wallet">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <div className="d-flex align-items-center">
                  <h4 className="modal-title me-2">Aadhar Wallet</h4>
                </div>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>

              <form onSubmit={handleAadhar}>
                <div className="contact-grids-tab">
                  <ul className="nav nav-underline" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="info-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#basic-info"
                        type="button"
                        role="tab"
                        aria-selected="true"
                      >
                        Basic Information
                      </button>
                    </li>
                    <li className="nav-item" role="presentation"></li>
                  </ul>
                </div>
                <div className="tab-content" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="basic-info"
                    role="tabpanel"
                    aria-labelledby="info-tab"
                    tabIndex={0}
                  >
                    <div className="modal-body pb-0 ">
                      <div className="row">
                        <div className="col-md-12"></div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Aadhar Token Wallet
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="number"
                              value={aadharTokenAmount || ""} // Provide a default value for controlled input
                              onChange={(e) =>
                                setAadharTokenAmount(e.target.value)
                              }
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Transaction Amount
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="number"
                              value={aadharAmount || ""} // Provide a default value for controlled input
                              className="form-control"
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-outline-light border me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        data-bs-dismiss="modal"
                        className="btn btn-primary"
                      >
                        Submit{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {openRazorPay && (
        <RenderRazorpay orderId={1} submitButton={submitButton} amount={200} />
      )}
    </div>
  );
};

export default Profile;
